<template>
  <v-container class="Subscription no-padding full-container">
    <PageHeader
      class="px-8 px-md-16 pt-16"
      :topic="$t('subscription.topic')"
      :title="$t(pageTitle)"
      :progressBarColor="progressBarColor"
      :stepCount="5"
      :step="currentPageIndex"
      :leftButtonLabel="leftButtonLabel"
      :rightButtonLabel="rightButtonLabel"
      :rightButtonIsDisabled="rightButtonIsDisabled"
      @clickLeftButton="onClickLeftButton"
      @clickRightButton="onClickRightButton"
    />
    <Component
      :is="currentPage"
      :stageTitle="stageTitle"
      :stageSubTitle="stageSubTitle"
      :formValid.sync="formValid"
    />
    <ScrollUpButton />
  </v-container>
</template>

<script>
  import MixinUi from '@/mixins/utils/ui.js'
  import CommonMixin from '@/mixins/store/CommonMixin'
  import SubscriptionMixin from '@/mixins/store/SubscriptionMixin'

  import ColoredTag from '@/components/ui/common/ColoredTag'
  import ScrollUpButton from '@/components/ui/partials/ScrollUpButton/ScrollUpButton'
  import PageHeader from '@/components/ui/partials/PageHeader/PageHeader'

  import getColor from '@/utils/getColor'
  import { createPersonPayload, cleanPersonPayload } from '@/utils/person.utils'
  import ApiService from '@/services/ApiService'

  import PersonalInfos from './steps-sub/PersonalInfos'
  import ContactInfos from './steps-sub/ContactInfos'
  import BankInfos from './steps-sub/BankInfos'
  import DocsInfos from './steps-sub/DocsInfos'
  import Validation from './steps-sub/Validation'

  export default {
    components: {
      PersonalInfos,
      ContactInfos,
      BankInfos,
      DocsInfos,
      Validation,
      ColoredTag,
      ScrollUpButton,
      PageHeader,
    },
    mixins: [MixinUi, CommonMixin, SubscriptionMixin,],
    data() {
      return {
        progressBarColor: getColor('_009ee0'),
        formValid: false,
      }
    },
    computed: {
      leftButtonLabel() {
        if (this.previousPage) {
          return this.$t('subscription.btn-back')
        } else {
          return this.$t('subscription.btn-back-start')
        }
      },
      rightButtonLabel() {
        if (this.nextPage) {
          return this.$t('subscription.btn-next')
        } else {
          return this.$t('subscription.btn-next-end')
        }
      },
      rightButtonIsDisabled() {
        // if (this.currentPage === PAGES.StagePersonal) {
        //   return this.isDirty || this.$store.state.subscription.selectedScenario === null
        // }

        return !this.formValid
      // return false
      },
    },
    methods: {
      async onClickRightButton() {
        if (this.nextPage) {
          this.$router.push({ name: 'Subscription', params: { page: this.nextPage, }, })

          return
        }
        const result = await this.patchProfile()
        if (result) {
          this.$router.push({ name: 'Profile', })
        }
      },
      onClickLeftButton() {
        if (this.previousPage) {
          this.$router.push({ name: 'Subscription', params: { page: this.previousPage, }, })

          return
        }
        this.$router.push({ name: 'Welcome', })
      },
      async patchProfile() {
        let payload = createPersonPayload(
          {
            ...this.selectedProfile,
          },
          this.requiredAttributes,
          this.optionalAttributes
        )
        payload = cleanPersonPayload(payload)
        this.toggleAppLoader(true)
        const result = await ApiService.updatePerson(this.selectedProfileIndex, payload)
        this.toggleAppLoader(false)
        if (result.errors) {
          this.$message({
            type: 'error',
            text: 'update_infos_error',
          })
          this.$store.commit('profile/setFormErrors', result.errors)

          return false
        } else {
          this.$message({
            type: 'success',
            text: 'update_infos_success',
          })
          await this.refreshSelectedProfile(true)
          this.$store.commit('profile/resetFormErrors')

          return true
        }
      },
    },
  }
</script>
